/*
 * Define a form page allowing the user to enter an email address
 * to receive a confirmation email.
 */
import * as yup from 'yup'
import css from './pages.module.css'
import { emailYup, selectionRequired } from '../validators'
import { joinClassNames } from '../utilities'
import { yesNoPlusInputPage } from './choicePage'
import { DependentField } from '../components/DependentField'

export const confirmationEmailPage = (propOverrides, dependencyName) => {
  const fieldName = 'confirmation_email_yn'
  const fieldNameOther = 'confirmation_email'
  const dependentFieldName = dependencyName || 'personal_email'

  const validation = yup.object().shape({
    [fieldName]: selectionRequired(),
    [fieldNameOther]: yup
      .string()
      .max(250, 'Email address cannot have more than 250 characters.')
      .test('select_yes_req', 'Please provide a valid email address', function(
        value
      ) {
        const selectedValue = this.parent[fieldName]
        if (selectedValue && selectedValue.includes('Yes'))
          return emailYup(true).isValid(value)
        return true
      })
  })

  const classNames = joinClassNames(css.printReview, css.choices)
  return yesNoPlusInputPage(
    {
      pageId: 'confirmation_email_page',
      fieldName: fieldName,
      label: '',
      className: classNames,
      classNameOther: css.printReview,
      labelClassName: '',
      fieldTypeOther: 'custom',
      fieldNameOther: fieldNameOther,
      labelOther: 'Email address',
      classNameLabelOther: css.padHint,
      hintOther:
        'Make sure the email address you enter is the one you wish to receive the complaint submission confirmation. Please update the email address if you wish to receive it at a different address.',
      validation: validation,
      ...propOverrides
    },
    {
      fieldName: fieldNameOther,
      content: DependentField,
      dependency: dependentFieldName
    }
  )
}
